import { render, staticRenderFns } from "./InsertProduct.vue?vue&type=template&id=5c5b324c&"
import script from "./InsertProduct.vue?vue&type=script&lang=js&"
export * from "./InsertProduct.vue?vue&type=script&lang=js&"
import style0 from "./InsertProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports